import { SodaWidget } from '@/ui';

import { Wrapper } from './utils';

export function Soda({ event, id }: { event: string; id?: string }) {
  return (
    <Wrapper id={id} className="max-w-(--breakpoint-xl)! flex-col">
      <SodaWidget brands={event} />
    </Wrapper>
  );
}
